module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Marca"
    },
    model: {
      value: (_vm.car.info.make),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "make", $$v)
      },
      expression: "car.info.make"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Modelo"
    },
    model: {
      value: (_vm.car.info.model),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "model", $$v)
      },
      expression: "car.info.model"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Dominio",
      "disabled": true
    },
    model: {
      value: (_vm.car.info.domain),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "domain", $$v)
      },
      expression: "car.info.domain"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "numeric",
      "name": "año",
      "label": "Año",
      "delay": "0",
      "disabled": true
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.car.info.year),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "year", $$v)
      },
      expression: "car.info.year"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Color"
    },
    model: {
      value: (_vm.car.info.color),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "color", $$v)
      },
      expression: "car.info.color"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Motor",
      "disabled": true
    },
    model: {
      value: (_vm.car.info.engine_number),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "engine_number", $$v)
      },
      expression: "car.info.engine_number"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Chasis",
      "disabled": true
    },
    model: {
      value: (_vm.car.info.chassis_number),
      callback: function($$v) {
        _vm.$set(_vm.car.info, "chassis_number", $$v)
      },
      expression: "car.info.chassis_number"
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-80f70ebc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/CarProps.vue
// module id = 253
// module chunks = 3